import React from "react";
import moment from "moment";
import async from "async";
import { connect } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { css } from "aphrodite";
import { callApi, validateToken } from "../../lib/utils";
import DayLine from "./DayLine";
import styles from "./style";
import DiaryRow from "./DiaryRow";
import DiaryDetails from "./DiaryDetails";
import PrepareDataset from "./PrepareDataset";
import DatePickerField from "../GenericComponents/DatePickerField";
import DiaryHeader from "../GenericComponents/Headers/DiaryHeader";
import CustomLoader from "../GenericComponents/CustomLoader";
import Footer from "../GenericComponents/Footer";
import "./popupContent.css";
import "./Diary.css";

class Diary extends React.Component {
  constructor(props) {
    super(props);
    let actDate = moment();
    try {
      actDate = moment
        .unix(this.props.profileData.activationDate / 1000)
        .startOf("day");
      if (!actDate.isValid()) {
        this.props.history.push("/dashboard");
      }
    } catch (e) {
      this.props.history.push("/dashboard");
    }
    const patientActivationDate = actDate;
    //console.log("patientActivationDate...", patientActivationDate.toString());
    this.state = {
      loading: false,
      selectedDate: moment().startOf("day").valueOf() / 1000,
      activationDate: patientActivationDate,
      startDate: this.getInitialDates("start", patientActivationDate),
      endDate: this.getInitialDates("end", patientActivationDate),
      calStartDate: this.getInitialDates("calStart", patientActivationDate),
      calEndDate: this.getInitialDates("calEnd", patientActivationDate),
      calStartDateMonth: this.getInitialDates(
        "calStartDateMonth",
        patientActivationDate
      ),
      calEndDateMonth: this.getInitialDates(
        "calEndDateMonth",
        patientActivationDate
      ),
      showPrevious: false,
      showNext: false,
      showDetails: false,
      diaryDetails: {},
      popupIsOpen: false,
      selectedRowType: "",
      diaryDetailsTimeline: null,
      showDateFilter: 0,
      careTrendDataSet: {},
      patientId: this.props.profileData.id,
      patientMedInfo: {},
    };
  }

  getInitialDates(type, activationDate) {
    switch (type) {
      case "start":
        var startDate = moment().subtract(this.props.interval - 1, "days");
        if (activationDate.isSameOrBefore(startDate)) {
          return startDate;
        } else {
          return activationDate.clone();
        }
      case "end":
        return moment();
      case "calStart":
        var calStartDate = moment().subtract(29, "days");
        //return calStartDate;
        if (activationDate.isSameOrBefore(calStartDate)) {
          return calStartDate;
        } else {
          return activationDate.clone();
        }
      case "calEnd":
        return moment();
      case "calStartDateMonth":
        var startDate = moment().subtract(this.props.interval - 1, "days");
        if (activationDate.isSameOrBefore(startDate)) {
          return startDate.clone().format("MMM-YYYY");
        } else {
          return activationDate.clone().format("MMM-YYYY");
        }
      case "calEndDateMonth":
        return moment().format("MMM-YYYY");
    }
  }

  componentWillMount() {
    document.addEventListener("mousedown", this.handleOutsideClick, false);
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      this.fetchData();
      this.fetchSymptomsEvents();
    });
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick, false);
  }

  componentDidUpdate(prevProps, prevState) {
    // || prevProps.selectedAppFeature !== this.props.selectedAppFeature
    if (prevProps.interval !== this.props.interval) {
      this.setCareTrendSearchDates(null, null);
      validateToken((err) => {
        if (err) {
          window.location = "/logout";
        }
        this.fetchData();
        this.fetchSymptomsEvents();
      });
    } else if (
      prevState.calStartDate !== this.state.calStartDate ||
      prevState.calEndDate !== this.state.calEndDate
    ) {
      validateToken((err) => {
        if (err) {
          window.location = "/logout";
        }
        this.fetchData();
        this.fetchSymptomsEvents();
      });
    }
    //this.closeTheDetailsView();
  }

  /**
   * This function calls the APIs to get the events data from the backend.
   * The showDetailsPanel flag is maintained to show and hide the details panel
   * on load of the page and when the page states changes.
   *
   * The expected behaviour is:
   * When the page loads the details panel should appear automatically. i.e.
   *    we have to show the details panel, on load of the page
   * When the user clicks on any date or when user navigates to the previous
   * or next month or when user selects the custom date, the details panel should get closed.
   *
   * So, to implement the above behaviour the showDetailsPanel flag is added in this function.
   * The showDetailsPanel flag holds a default value as true. so, whenever the fetchData function
   * is invoked without sending this flag it will be considered as true and the details panel will
   * appear after getting the data for all types of events.
   */
  fetchData = () => {
    this.setState({ loading: true });
    const { eventTypeList, appModules } = this.props;
    let typesArr = [];
    eventTypeList.forEach((event) => {
      let tempObj = {};
      switch (event.eventNameConstant) {
        case "BL":
          tempObj.id = event.id;
          tempObj.type = "bleeds"; //not available
          tempObj.module = true;
          break;
        case "AMS" || "AMIP" || "AME":
          tempObj.id = 3;
          tempObj.type = "abnormalMotion";
          tempObj.module = appModules.active?.SD ? true : false;
          break;
        case "TL":
          tempObj.id = event.id;
          tempObj.type = "treatmentLogs"; // not available
          tempObj.module = true;
          break;
        case "MEDRMNDR":
          tempObj.id = event.id;
          tempObj.type = "reminders";
          tempObj.module = this.props.appModules.active?.MEDC?.includes(
            "MEDICATION_REMINDERS"
          )
            ? true
            : false;
          break;
        case "MDCLVST":
          tempObj.id = event.id;
          tempObj.type = "visits";
          tempObj.module = appModules.active?.MV ? true : false;
          break;
        case "WL":
          tempObj.id = event.id;
          tempObj.type = "weightlogs";
          tempObj.module = true;
          break;
        case "HL":
          tempObj.id = event.id;
          tempObj.type = "heightlogs";
          tempObj.module = true;
          break;
        case "ALRGY":
          tempObj.id = event.id;
          tempObj.type = "allergy";
          tempObj.module = appModules.active?.ALGY ? true : false;
          break;
        case "CALLALRT":
          tempObj.id = event.id;
          tempObj.type = "help";
          tempObj.module = true;
          break;
        case "HRTHR":
          tempObj.id = event.id;
          tempObj.type = "hrmLogs";
          tempObj.module = appModules.active?.HRM ? true : false;
          break;
        default:
          return null;
      }
      typesArr.push(tempObj);
    });

    let apiReqs = [];
    typesArr.filter((type) => {
      return type.module;
    }).forEach((eventType) => {
      apiReqs.push((cb) => {
        let params = {
          patientId: this.state.patientId,
          eventType: eventType.id,
          start: moment(this.state.calStartDate).valueOf(),
          end: moment(this.state.calEndDate).valueOf(),
        };
        //console.log("eventType...", params.eventType);

        //callApi(`/api/patient/events`, params, "POST")
        callApi(`/api/patient/events/bytype/${eventType.id}`, {}, "GET")
          .then((data) => {
            let careTrendDataSet = { ...this.state.careTrendDataSet };
            if (data.status === 200) {
              let result = data.data.data;
              //dataset[eventType] = PrepareDataset(eventType, data[0], this.state.calStartDate, this.state.calEndDate);
              careTrendDataSet[eventType.type] = PrepareDataset(
                eventType.type,
                result,
                this.state.calStartDate,
                this.state.calEndDate
              );
              //console.log("careTrendDataSet...", careTrendDataSet);
              //console.log("type...", eventType.type);
              this.setState({
                careTrendDataSet,
                loading: false,
              });
            }
            cb();
          })
          .catch(cb);
      });
    });
    async.parallel(apiReqs, (err) => {
      this.setState({ loading: false });
      if (err) this.setState({ error: err.message, loading: false });
    });

    /*this.setState({
        careTrendDataSet: dataset
     });*/
  };

  fetchSymptomsEvents = () => {
    if (this.props.appModules.active?.SL) {
      this.setState({ loading: true });
      //.log("types", typesArr);
      let params = {
        start: moment(this.state.calStartDate).valueOf(),
        end: moment(this.state.calEndDate).valueOf(),
      };
      callApi("/api/patient/symptoms/list", params, "POST")
        .then((response) => {
          let careTrendDataSet = { ...this.state.careTrendDataSet };
          careTrendDataSet["symptoms"] = PrepareDataset(
            "symptoms",
            response.data.data.symptoms,
            this.state.calStartDate,
            this.state.calEndDate
          );
          this.setState({
            careTrendDataSet,
            loading: false,
          });
        })
        .catch((err) => {
          console.log("err: ", err);
          this.setState({ loading: false });
        });
    }
  };

  setCareTrendSearchDates = (stDate, edDate) => {
    //let newStDate = moment();
    let startDate = null;
    let calStartDate = null;
    let calEndDate = null;
    let endDate = null;
    let showPrevious = true;
    let calStartDateMonth = "";
    let calEndDateMonth = "";

    if (stDate !== null && edDate !== null) {
      //newStDate = moment(stDate).startOf("day");
      startDate = moment(stDate).startOf("day");
      if (startDate.isBefore(this.state.activationDate)) {
        startDate = this.state.activationDate.clone();
      }

      endDate = moment(edDate).endOf("day");
      let tempCalStartDate = moment(edDate).subtract(29, "days").startOf("day");
      if (tempCalStartDate.isBefore(this.state.activationDate)) {
        tempCalStartDate = this.state.activationDate.clone();
      }
      if (tempCalStartDate.isSameOrBefore(startDate)) {
        showPrevious = false;
        tempCalStartDate = startDate;
      }

      calStartDate = tempCalStartDate;
      calEndDate = endDate.clone();
      calStartDateMonth = calStartDate.format("MMM YY");
      calEndDateMonth = calEndDate.format("MMM YY");
    } else {
      //newStDate = moment().subtract(this.props.interval - 1, "days");
      startDate = moment().subtract(this.props.interval - 1, "days");
      if (startDate.isBefore(this.state.activationDate)) {
        startDate = this.state.activationDate.clone();
      }
      endDate = moment();
      //calStartDate = moment().subtract(29, "days");

      let tempCalStartDate = moment().subtract(29, "days");
      if (tempCalStartDate.isSameOrBefore(startDate)) {
        showPrevious = false;
        tempCalStartDate = startDate;
      }

      calStartDate = tempCalStartDate;
      if (calStartDate.isBefore(this.state.activationDate)) {
        calStartDate = this.state.activationDate.clone();
      }

      calEndDate = moment();
      calStartDateMonth = calStartDate.format("MMM YY");
      calEndDateMonth = calEndDate.format("MMM YY");
    }
    this.setState({
      startDate,
      endDate,
      calStartDate,
      calEndDate,
      calStartDateMonth,
      calEndDateMonth,
      showPrevious,
      showNext: false,
    });
  };

  preiousMonth = () => {
    let showNext = true;
    let showPrevious = true;
    let newStDate = this.state.calStartDate.subtract(29, "days");

    if (newStDate.isBefore(this.state.startDate)) {
      showPrevious = false;
      newStDate = this.state.startDate.clone();
    }

    if (newStDate.isBefore(this.state.activationDate)) {
      newStDate = this.state.activationDate.clone();
    }

    let newEdDate = newStDate.clone().add(29, "days");

    if (this.state.endDate.isSame(newEdDate)) {
      showNext = false;
    }

    if (newEdDate.isAfter(moment())) {
      newEdDate = moment();
    }

    this.setState({
      calStartDate: newStDate,
      calEndDate: newEdDate,
      calStartDateMonth: newStDate.format("MMM-YYYY"),
      calEndDateMonth: newEdDate.format("MMM-YYYY"),
      showPrevious,
      showNext,
    });
  };

  nextMonth = () => {
    let showPrevious = true;
    let showNext = true;
    let newStDate = this.state.calStartDate.add(29, "days");

    if (newStDate.isAfter(moment())) {
      newStDate = moment();
    }

    let newEdDate = newStDate.clone().add(29, "days");

    if (newEdDate.isAfter(this.state.endDate)) {
      showNext = false;
      newEdDate = this.state.endDate.clone();
      newStDate = this.state.endDate.clone().subtract(29, "days");

      if (newStDate.isBefore(this.state.activationDate)) {
        newStDate = this.state.activationDate.clone();
      }
    }

    if (newStDate.isBefore(this.state.startDate)) {
      showPrevious = false;
    }
    this.setState({
      calStartDate: newStDate,
      calEndDate: newEdDate,
      calStartDateMonth: newStDate.format("MMM-YYYY"),
      calEndDateMonth: newEdDate.format("MMM-YYYY"),
      showPrevious,
      showNext,
    });
  };

  selectDate = (e, selectedDate) => {
    if (this.state.selectedDate !== selectedDate) {
      this.setState({
        selectedDate,
        showDetails: false,
      });
    } else {
      this.setState({
        selectedDate: 0,
        showDetails: false,
      });
    }
  };

  //date
  showDetailsHandle = () => {
    //console.log("showDetailsHandle........");
    this.setState({
      showDetails: !this.state.showDetails,
      popupIsOpen: false,
    });
  };

  closeDiaryDetails = () => {
    this.setState({
      showDetails: false,
      selectedRowType: "",
      diaryDetailsTimeline: null,
    });
  };

  /**
   * This function will be executed after getting the data of
   * all types of events. This function will open the
   * details view automatically after the page loads and when we get
   * the whole data of all type of events
   */
  handleOpenPopupOnLoad = (selectedRowType, date) => {
    if (
      this.state.selectedDate !== 0 &&
      moment
        .unix(this.state.selectedDate)
        .isSame(moment.unix(date / 1000).startOf("day"))
    ) {
      this.setState({
        popupIsOpen: true,
        selectedRowType,
        diaryDetailsTimeline: this.diaryDetails(),
      });
    }
  };

  /**
   * This function will be executed after clicking on the event icon in
   * a specific row
   */
  handleOpenPopup = (selectedRowType, date) => {
    let sDate = moment
      .unix(date / 1000)
      .startOf("day")
      .valueOf();
    //console.log("sDate...", sDate);

    this.setState({
      selectedDate: sDate / 1000,
      popupIsOpen: true,
      selectedRowType,
      diaryDetailsTimeline: this.diaryDetails(),
    });
  };

  diaryDetails = () => {
    let timelineArray = [];
    //Object.keys(dataObj).forEach(typeOfData => {
    let dataObj = this.state.careTrendDataSet;
    Object.keys(dataObj).forEach((typeOfData) => {
      if (dataObj[typeOfData] !== undefined) {
        dataObj[typeOfData].forEach((obj) => {
          if (obj.reported) {
            obj.data.forEach((d) => {
              timelineArray.push({ tz: d.timestamp, text: d.type });
            });
          }
        });
      }
    });
    return timelineArray;
  };

  handleClosePopup = () => {
    this.setState({
      popupIsOpen: false,
    });
  };

  openDateFilter = () => {
    if (this.state.showDateFilter === 1) {
      this.setState({ showDateFilter: 0 });
    } else {
      this.setState({ showDateFilter: 1 });
    }
  };

  closeCustomDateFilter = () => {
    this.setState({ showDateFilter: 0 });
  };

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      } else if (
        e.target.attributes !== null &&
        e.target.attributes.getNamedItem("class") !== null &&
        e.target.attributes.getNamedItem("class").nodeValue !== null &&
        e.target.attributes
          .getNamedItem("class")
          .nodeValue.includes("react-datepicker")
      ) {
        return;
      }
      if (this.state.showFilter === 1) this.openFilter();
      else if (this.state.showDateFilter === 1) this.openDateFilter();
    }
  };

  handleChangeStart = (date) => {
    let dateStart = moment(date).startOf("day");
    this.setCareTrendSearchDates(dateStart, null);
  };

  handleChangeEnd = (date) => {
    let dateEnd = moment(date).endOf("day");
    this.setCareTrendSearchDates(null, dateEnd);
  };

  render() {
    let patient = this.props.profileData;
    let patientData = {
      recordId: 0,
      name: "",
      age: "",
      city: "",
    };
    if (patient !== undefined) {
      let age = patient.patientData.dob !== null
        ? Math.floor(
          moment.duration(moment().diff(patient.patientData.dob)).asYears()
        )
        : "";
      patientData = {
        ...patientData,
        recordId: patient.recordId,
        patientId: patient.id,
        age: age,
        city: patient.patientData !== undefined ? patient.patientData.city : "",
      };
    }
    return (
      <div className="diary-page">
        <CustomLoader loading={this.state.loading} />
        <DiaryHeader
          title={"Care Trend"}
          setCareTrendSearchDates={this.setCareTrendSearchDates}
        />
        <div className="diary-page-content">
          <div className={css(styles.grid)}>
          <Row
            className={`${css(styles.gridRow)} diary-info-row`}
            style={{
              backgroundColor: "#747474",
              boxShadow: "inset 0px 6px 15px -8px rgba(0,0,0,0.45)",
              color: "#fff",
            }}
          >
            <Col
              xs={12}
              sm={4}
              md={3}
            >
              {patientData.recordId}
            </Col>
            <Col xs={12} sm={4} md={6}>
              <span>{patientData.age !== "" ? `${patientData.age} years - ` : patientData.age}</span>
              <span style={{ textTransform: "capitalize" }}>
                {patientData.city}
              </span>
            </Col>
            <Col xs={12} sm={4} md={3}>
              <div>
                <span>{this.state.startDate.format("MMM DD, YYYY")}</span> -{" "}
                <span>{this.state.endDate.format("MMM DD, YYYY")}</span>
              </div>
            </Col>
            {/* <Col xs={12} sm={6} md={4}>
              {" "}
              <div className={css(styles.divIconsPatient)}>
                <a
                  onClick={this.openDateFilter}
                  className={css(styles.iconsMenu)}
                  title="Date Filter"
                >
                  <img
                    className={css(styles.imageiconsMenu)}
                    alt="filter"
                    src="/images/header/patient_calendar.png"
                  />
                </a>

                {this.state.showDateFilter === 1 ? (
                  <div
                    className={css(styles.divDateFilter)}
                    ref={(node) => (this.node = node)}
                  >
                    <label style={{ fontSize: "13px" }}>
                      Custom Date Filter
                    </label>
                    <span style={{ float: "right" }}>
                      <img
                        src={"/images/no.png"}
                        className={css(styles.imageiconsMenu)}
                        alt="close"
                        title={"close"}
                        onClick={this.closeCustomDateFilter}
                      ></img>
                    </span>
                    <div
                      className="customDatePickerWidth"
                      style={{
                        background: "#eee",
                        display: "inline-flex",
                        color: "#000",
                        padding: "0 0 0 0px",
                      }}
                    >
                      <DatePickerField
                        name={"dob"}
                        value={this.state.formInputs.dob}
                        minDate={new Date().setFullYear(
                          new Date().getFullYear() - 100
                        )}
                        maxDate={new Date()}
                        placeholder="Enter date of birth..."
                        action={this.handleChangeStart}
                        selectsStart
                        disabledKeyboardNavigation
                        required={true}
                      />

                      <DatePickerField
                        name={"dob"}
                        value={this.state.formInputs.dob}
                        minDate={new Date().setFullYear(
                          new Date().getFullYear() - 100
                        )}
                        maxDate={new Date()}
                        placeholder="Enter date of birth..."
                        action={this.handleChangeEnd}
                        selectsStart
                        disabledKeyboardNavigation
                        required={true}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </Col> */}
          </Row>

          <Row
            style={{
              paddingTop: "0",
              paddingBottom: "0px",
              margin: "0px",
              textTransform: "uppercase",
            }}
          >
            <Col
              xs={6}
              sm={6}
              md={6}
              style={{
                backgroundColor: "#4E4E4E",
                color: "#FFF",
                textAlign: "left",
              }}
            >
              <span style={{ paddingLeft: "2%" }}>
                {this.state.calStartDateMonth}
              </span>
            </Col>
            <Col
              xs={6}
              sm={6}
              md={6}
              style={{
                backgroundColor: "#4E4E4E",
                color: "#FFF",
                textAlign: "right",
              }}
            >
              <span style={{ paddingRight: "2%" }}>
                {this.state.calEndDateMonth}
              </span>
            </Col>
          </Row>
          <Row style={{ paddingTop: "0", margin: "0px" }}>
            <Col xs={12} className="p-0">
            <div className="diary-timeline-wrapper">
            <Table responsive={true} style={{ border: "0" }}>
              <DayLine
                showPrevious={this.state.showPrevious}
                showNext={this.state.showNext}
                preiousMonth={this.preiousMonth}
                nextMonth={this.nextMonth}
                calStartDate={this.state.calStartDate}
                calEndDate={this.state.calEndDate}
                selectedDate={this.state.selectedDate}
                selectDate={this.selectDate}
              />
              <DiaryRow
                dataObj={this.state.careTrendDataSet}
                popupIsOpen={this.state.popupIsOpen}
                selectedDate={this.state.selectedDate}
                selectedRowType={this.state.selectedRowType}
                showDetails={this.showDetailsHandle}
                handleOpenPopup={this.handleOpenPopup}
                handleClosePopup={this.handleClosePopup}
              />
            </Table>
            </div>
            </Col>
            {this.state.showDetails ? (
              <DiaryDetails
                openCanvas={this.state.showDetails}
                date={this.state.selectedDate}
                close={this.closeDiaryDetails}
                dataObj={this.state.careTrendDataSet}
              />
            ) : null}
          </Row>
        </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default connect(
  (store) => {
    return {
      interval: store.diary.interval,
      profileData: store.dashboard.profileData,
      eventTypeList: store.dashboard.eventTypeList,
      appModules: store.dashboard.appModules,
    };
  },
  (dispatch) => {
    return {};
  }
)(Diary);
